module.exports = __webpack_public_path__ + "img/5_20.11d3073a.png";